export const qaLabelModals = {
    closeButton: 'modal--close-button',
    // TO DO: Deprecate
    toastMessage: 'toast-message'
};
export const qaLabelCommon = {
    toastText: 'toast-message-text',
    dropdownFirstOption: '[id*="-option-0"]',
    classControl: '[class$=-control]',
    reactSelectOptions: '[id^=react-select]'
};
